// extracted by mini-css-extract-plugin
export var btnBack = "HelpCenterTpl-module--btnBack--63759";
export var content = "HelpCenterTpl-module--content--6ee9f";
export var icon = "HelpCenterTpl-module--icon--ee355";